<template>
  <controller>
    <page-header title="Matrícula" />
    <matricula-controller 
      :action="action"
      :step="step"
      :idMatricula="idMatricula"
      :auto="auto"
    />
  </controller>
</template>

<script>
import MatriculaController from '@/components/matriculas/4/template/MatriculaController.vue'

export default {
  components: {
    MatriculaController
  },
  props: {
    action: String,
    step: String,
    idMatricula: [String, Number],
    auto: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>